import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";

function App() {
  useEffect(() => {
    document.title = "A Wider Horizon — Jacob Seal";
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#F7F4EB",
            color: "#111314",
            border: "1px solid #D8D2C1",
            borderRadius: "0px",
            fontFamily: "Outfit, sans-serif",
            fontWeight: 300,
            letterSpacing: "0.02em",
          },
        }}
      />
    </div>
  );
}

export default App;
